/**
 * A link to a certain page, an anchor tag
 */

import styled, { css } from 'styled-components';

const rigidplyFooterFix =
  process.env.REACT_APP_PROJECT_NAME === 'rigidply' &&
  css`
    height: auto;
    min-height: 6.1vh;
    flex-shrink: 0;
    align-items: center;
  `;

const ModalFooter = styled.div`
  margin-top: auto;
  background-color: white;
  display: flex;
  align-items: center;
  overflow: visible;
  padding: 10px 12px;
  border-radius: 0px 0px 5px 5px;
  height: 6.1vh;
  font-size: 1.5vh;
  justify-content: space-between;
  border-top: 1px solid #ddd;
  z-index: 1;
  box-shadow: rgba(0, 0, 0, 0.08) 0px -4px 8px;
  gap: 2;
  ${rigidplyFooterFix}
`;

export default ModalFooter;
